import { useToast } from "vue-toastification";

const toast = useToast();

const fire = (
    message:string, 
    timeout?:number | undefined, 
    type?: "success" | "warning" | "error" 
):any =>
{
    if (!timeout)
    {
        timeout = 3500;
    }

    if (!type)
    {
        type = "success";
    }
  
    // show the toast
    return toast[type](message, {
        timeout: timeout
    });
};

interface ToastMessage {
    message: string;
    timeout?: number;
}

interface ToastQueue {
    success: Array<ToastMessage>,
    error: Array<ToastMessage>,
    warning: Array<ToastMessage>
};

// TODO - debounce the toasts in case of a lot of messages ...
const queue:ToastQueue = {
    success: [],
    error: [],
    warning: []
};

let timeoutId:number | null = null;

const checkQueue = () =>
{
    let successStr = "";
    let successTimeout = 0;
    let errorStr = "";
    let errorTimeout = 0;
    let warnStr = "";
    let warnTimeout = 0;

    // only add the message if the message is not already in the queue ...

    while(0 < queue.success.length)
    {
        let row:ToastMessage | undefined = queue.success.shift();

        if (row === undefined)
        {
            continue;
        }
        
        else if (successStr.indexOf(row.message) < 0)
        {
            successStr += " " + row.message + " ";
        }

        successTimeout = Math.max(successTimeout, row.timeout || 0);
    }

    while(0 < queue.error.length)
    {
        let row:ToastMessage | undefined = queue.error.shift();
        
        if (row === undefined)
        {
            continue;
        }

        else if (errorStr.indexOf(row.message) < 0)
        {
            errorStr += " " + row.message + " ";
        }

        errorTimeout = Math.max(errorTimeout, row.timeout || 0);
    }

    while( 0 < queue.warning.length)
    {
        let row:ToastMessage | undefined = queue.warning.shift();
        
        if (row === undefined)
        {
            continue;
        }

        else if (warnStr.indexOf(row.message) < 0)
        {
            warnStr += " " + row.message + " ";
        }

        warnTimeout = Math.max(warnTimeout, row.timeout || 0);
    }

    if (successStr)
    {
        fire(successStr, successTimeout, "success");
    }

    if (errorStr)
    {
        fire(errorStr, errorTimeout, "error");
    }

    if (warnStr)
    {
        fire(warnStr, warnTimeout, "warning");
    }
    
};

class Toast
{

    success(message:string, timeout?:number | undefined):void
    {
        clearTimeout(timeoutId || 0);
        queue.success.push({ message: message, timeout: timeout})
        timeoutId = window.setTimeout(checkQueue, 500);
    }

    error(message:string, timeout?:number):void
    {
        clearTimeout(timeoutId || 0);
        queue.error.push({ message: message, timeout: timeout });
        timeoutId = window.setTimeout(checkQueue, 500);
    }

    warning(message:string, timeout?:number):any
    {
        clearTimeout(timeout);
        queue.warning.push({ message: message, timeout: timeout });
        timeoutId = window.setTimeout(checkQueue, 500);
    }

}

const singleton = new Toast();
export default singleton;